import type { Cache, UpdatesConfig, Variables } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { AgentTuitionPolicyCancelMutation } from '@/graphql/generated/graphql';

/**
 * After Harmon cancels a tuition policy, refresh entity-scoped membership lists so policy
 * dropdowns (cancel / resend / documents) drop the cancelled tuition row without a full reload.
 */
const agentTuitionPolicyCancelCache: UpdatesConfig['Mutation'] = {
  agentTuitionPolicyCancel: (_result: AgentTuitionPolicyCancelMutation, _args: Variables, cache: Cache) => {
    invalidateQuery('memberships', cache);
  },
};

export default agentTuitionPolicyCancelCache;
